import { render, staticRenderFns } from "./ChangePasswordComponent.vue?vue&type=template&id=4f25b311"
import script from "./ChangePasswordComponent.vue?vue&type=script&lang=ts"
export * from "./ChangePasswordComponent.vue?vue&type=script&lang=ts"
import style0 from "./ChangePasswordComponent.vue?vue&type=style&index=0&id=4f25b311&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports